import * as React from "react";

function LinkIcon(
  props: React.SVGProps<SVGSVGElement> & {
    pathprops?: React.SVGProps<SVGPathElement>;
  }
) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 18" fill="none" {...props}>
      <path
        d="M5.277 18a5.276 5.276 0 01-3.731-9.01L6.99 3.546a5.277 5.277 0 117.463 7.464l-.59.59-1.509-1.508.595-.594a3.146 3.146 0 00-.005-4.444 3.22 3.22 0 00-4.447 0l-5.443 5.444a3.143 3.143 0 000 4.448 3.22 3.22 0 004.447 0l1.508 1.508A5.245 5.245 0 015.277 18z"
        fill="#000"
        {...props.pathprops}
      />
      <path
        d="M13.277 16a5.277 5.277 0 01-3.731-9.01l.59-.589 1.508 1.51-.59.588a3.145 3.145 0 000 4.447 3.22 3.22 0 004.448 0l5.444-5.445a3.148 3.148 0 000-4.446 3.22 3.22 0 00-4.447 0l-1.508-1.51a5.277 5.277 0 117.463 7.465l-5.443 5.443A5.247 5.247 0 0113.28 16h-.002z"
        fill="#000"
        {...props.pathprops}
      />
    </svg>
  );
}

const MemoLinkIcon = React.memo(LinkIcon);
export default MemoLinkIcon;
